import { render, staticRenderFns } from "./TgSideBar.vue?vue&type=template&id=8a87d186&"
import script from "./TgSideBar.vue?vue&type=script&lang=js&"
export * from "./TgSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports